<template>
  <v-container fluid>
    <!--header--->
    <header>
      <!--navigation drawer on desktop containing user name image and navigation items and logout buttons-->
      <v-navigation-drawer v-model="drawer" app>
        <!---user image------------>
        <v-card elevation="0" color="var(--purple)" class="py-2 mb-2">
          <v-card-title class="d-flex justify-center align-center">
            <v-avatar size="80" color="white">
              <span
                v-if="!profile_picture_url"
                class="text-uppercase black--text"
                >{{ firstname + ' ' + lastname }}</span
              >
              <img
                :src="profile_picture_url"
                :alt="firstname + ' ' + lastname"
                v-else
              />
            </v-avatar>
          </v-card-title>
          <v-card-subtitle class="mb-3 mt-0 white--text text-center">
            <span class="text-capitalize">{{ firstname }} {{lastname}}</span>
            <br />
          </v-card-subtitle>
        </v-card>
        <!--  navigation  items-->
        <side-navigation></side-navigation>

        <!-- logout button--->
        <v-btn
          text
          style="position: relative; bottom: 0"
          class="d-sm-none d-none"
        >
          <v-icon>mdi-logout-variant</v-icon>
          <span class="d-inline-block grey-text text-small ml-2">Log out</span>
        </v-btn>
      </v-navigation-drawer>
      <!--------------application header for large screens------------->
      <v-app-bar
        elevation="1"
        app
        class="elevation-1"
        color="white"
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title  class="text--secondary ml-n5">
          <small>edwork</small>
          <!-- <app-logo ></app-logo> -->
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <!-------search- button in app header------------>
        <v-btn icon @click="goToPage('search')" class="d-none">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>

        <!--notification button in app header-->
        <v-btn icon @click="goToPage('notification')"  >
          <!-----------Load  total notification "context" form central store------------>
          <!--if notification, show badge else, show just the notification icon--->
          <template v-if="totalNotification">
            <v-badge top size="12" dot right color="var(--red)">
              <v-icon>mdi-bell-outline</v-icon></v-badge
            >
          </template>
          <template v-else>
            <v-icon>mdi-bell-outline</v-icon>
          </template>
        </v-btn>

        <!---------avatar- in header menu---------->
        <v-menu
          offset-x
          offset-y
          rounded
          open-on-click
          class="d-inline-block"
          transition="slide-y-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-avatar size="30" color="var(--purple)" dark v-bind="attrs" v-on="on">
              <small
                v-if="!profile_picture_url"
                class="text-uppercase white--text pa
                -2"
                >{{ firstname[0] + lastname[0] }}</small
              >
              <img
                :src="profile_picture_url"
                :alt="firstname + ' ' + lastname"
                v-else
              />
            </v-avatar>
          </template>
          <!--menu option :: go to profile--------->
          <v-list>
            <v-list-item
              class="small grey-text"
              :to="{ name: 'profile', params: { user: userId } }"
            >
              <v-icon>mdi-account-circle</v-icon>
              <span class="d-inline-block grey-text text-small ml-2"
                >Profile</span
              >
            </v-list-item>
            <!------help----------->
            <v-list-item class="small grey-text" :to="{ name: 'feedback' }">
              <v-icon>mdi-help-circle-outline</v-icon>
              <span class="d-inline-block grey-text text-small ml-2">Help</span>
            </v-list-item>
            <!--menu option :: go to settings--------->
            <v-list-item :to="{ name: 'settings', params: { user: userId } }">
              <v-icon>mdi-cog-outline</v-icon>
              <span class="d-inline-block grey-text text-small ml-2"
                >Settings</span
              >
            </v-list-item>
            <v-divider></v-divider>
            <!--menu option :: logout--------->
            <v-list-item @click="signout">
              <v-icon>mdi-logout-variant</v-icon>
              <span class="d-inline-block grey-text text-small ml-2"
                >Log out</span
              ></v-list-item
            >
          </v-list>
        </v-menu>
      </v-app-bar>
    </header>

    <!---main- entry point of user profile routing-->
    <v-row justify="center" align="center">
      <v-col cols="12" sm="8">
        <transition
          mode="out-in"
          enter-active-class="animate__animated animate__fadeIn"
          leave-active-class="animate__animated animate__fadeOut"
        >
          <slot></slot>
        </transition>
      </v-col>
    </v-row>
    <!--------------------bottom--navigation----------------------->
    <bottom-navigation class="d-sm-none d-none"></bottom-navigation>
  </v-container>
</template>

<script>
//app logo
// import app log
//side navigation
import SideNavigation from "@/components/UserAccountSideNavigation.vue";
import BottomNavigation from "@/components/UserAccountBottomNavigation.vue";
//import central store for the sake of notification
import store from "@/store";

//import method to fetch notification from API and mount ot on vue "mounted" hook
import { mapActions } from "vuex";

export default {
  components: {
    SideNavigation,
    BottomNavigation,
    // AppLogo: () => import("@/components/AppLogo"),
  },

  data: () => ({
    //default bottom nav item on mobile
    // value: 0,
    active: true,
    query: "",
    drawer: null,
  }),

  mounted() {
    this.fetch_notification();
  },

  methods: {
    //destructure the login action imported from central store into login method into local login method, take caution both method don't have same name to avoid issues
    ...mapActions({
      fetch_notification: "notification/fetch_notification",
      logout: "auth/logout",
    }),

    signout() {
      this.logout();
      this.$router.push({ name: "login" });
    },
    //go to the page name
    goToPage(pageName) {
      this.$router.push({ name: pageName });
    },
  },

  computed: {
    //load notification total notification  from central store when user is authenticated
    totalNotification: () => store.getters["notification/count"],
    //get user profile from central store here
    firstname: () => store.getters["auth/user"].firstname,
    lastname: () => store.getters["auth/user"].lastname,
    email: () => store.getters["auth/user"].email,
    bio: () => store.getters["auth/user"].bio,
    username: () => store.getters["auth/user"].username,
    phone: () => store.getters["auth/user"].phone,
    profile_picture_url: () => store.getters["auth/user"].profile_picture_url,
    //for handling router params
    current_user: () => store.getters["auth/user"],
    userId() {
      const { user_id, username } = this.current_user;
      //if the username has not been set, use  truncated user_id as router params
      const current_user_id = username ? username : user_id;
      return current_user_id;
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 600px) {
  .v-navigation-drawer {
    background: var(--purple) !important;
  }
  .v-app-bar {
    background: var(--white) !important;
  }
  .v-app-bar .v-icon,
  .v-app-bar .v-toolbar-title {
    color: var(--black);
  }
}
</style>